/**
 * Created by shiyonggao on 2019/11/28.
 */
import Message from "./message";
import {
    MessageBox
} from 'element-ui';
const tips = {
    operateFailMsg: '操作失败！',
};

class error {

    /**
     * 无权限用户处理
     * @param message
     * @param rootState
     */
    noAccessPage(message, rootState) {
        let arrToken = [
            'A Token was not found in the TokenStorage',
            'Access JWT Token string not found in request or Jwt Token Invalid',
        ];
        let flag = false;
        for (let key in arrToken) {
            if (message.indexOf(arrToken[key]) !== -1) {
                flag = true;
                break;
            }
        }

        if (flag) {
            rootState.$helper.helper.login();
        }
    }

    /***
     * 错误统一处理
     */
    error(error, {state, commit, dispatch, rootState}) {
        if (rootState.$config.isDebug) {
            if (error['response']) {
                console.error(error['response']);
            }
            else {
                console.error(error);
            }
            if (typeof error['response'].data.extra.error_type !== 'undefined' || (error.data && typeof error.data.extra.error_type !== 'undefined')) {
                const errorType = error['response'].data.extra.error_type || error.data.extra.error_type;
                if (errorType === 'third_party_api') {
                    setTimeout(() => {
                        rootState.$helper.helper.logout();
                    }, 300);
                    return;
                }
            }
            
            if (error['response'].data.exception.message || error.data.exception.message) {
                MessageBox.alert(error['response'].data.exception.message || error.data.exception.message,
                    '提示', {
                        type: 'error',
                    });
            }
            else {
                alert(`ajax-erro ${JSON.stringify(error['response'])}`);
            }

            return;
        }

        let message = tips.operateFailMsg;

        /** 无权限返回内容**/
        if (error['response'] &&
            error['response']['data'] &&
            error['response']['data']['mess']
        ) {
            let message = error['response']['data']['mess'];
            if (message === 'No permission to access this url') {
                /** 已在无权限提示页面不再跳转**/
                if (rootState.$page !== 'noAccess') {
                    console.log('error-response-noAccess');
                    // rootState.$route('noAccess');
                }
                return;
            }
        }

        /** 无权限处理**/
        if (error['response'] &&
            error['response']['data'] &&
            error['response']['data']['exception'] &&
            error['response']['data']['exception']['message']
        ) {

            message = error['response']['data']['exception']['message'];
            this.noAccessPage(message, rootState);
        }

        /** 统一提示**/
        Message.alert({
            message: message,
            reload: false
        }, {state, commit, dispatch, rootState});
    }

}

export default new error();



// WEBPACK FOOTER //
// ./website/helper/error.js